import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password_input = _resolveComponent("password-input")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Change Password",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Change Password",
        color: "primary",
        task: _ctx.task,
        disable: !_ctx.canChange,
        onClick: _ctx.changePassword
      }, null, 8, ["task", "disable", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createVNode(_component_password_input, {
          label: "Current Password",
          modelValue: _ctx.currentPassword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event)),
          outlined: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_password_input, {
          label: "New Password",
          modelValue: _ctx.newPassword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
          outlined: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_password_input, {
          label: "Confirm New Password",
          modelValue: _ctx.confirmNewPassword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmNewPassword) = $event)),
          outlined: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 512))
}